import { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { ERRORS, URL_VALIDATOR } from '../../../constants/AppConstants';
import { updateWebSite } from '../../../services/websitesService';
import { useMutation } from 'react-query';
import { useAppContext } from '../../../appProvider/contextProvider';
import { toast } from 'react-toastify';


const EditWebsite = () => {
    const history = useHistory();

    const location = useLocation();
    const website = location.state;

    const {updateWebsites, 
        isDirty, 
        setIsDirty,
        setPathToNavigate,
        setDiscardPromptOpen,
    } = useAppContext();

    const [title, setWebsiteTitle] = useState(website.title);
    const [url, setWebsiteUrl]  = useState(website.url);
    
    const [titleError, setTitleError] = useState(null);
    const [urlError, setURLError] = useState(null);

    const [gpmKey, setGpmKey] = useState(website?.gpm_account_key || '');
    const [gpmKeyError, setGpmKeyError] = useState(null);

    const [gpmRestAPIKey, setGpmRestAPIKey] = useState(website?.gpm_rest_api_key || '');
    const [gpmRestAPIKeyError, setGpmRestAPIKeyError] = useState(null);

    const [safariWebPushId, setSafariWebPushId] = useState(website?.safari_old_web_push_id || '');
    const [safariWebPushIdError, setSafariWebPushIdError] = useState(null);


    const handelTitleValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.WEBSITE_TITLE_REQUIRED);
        }else if(value.trim().length >= 150 ) {
            setTitleError(ERRORS.WEBSITE_TITLE_MAX_LENGTH);
        }
        else {
            setTitleError(null);
        }
        setWebsiteTitle(value);
    }

    const handelUrlValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setURLError(ERRORS.WEBSITE_TITLE_REQUIRED);
        } else if(!value.toLowerCase().startsWith('https://')) {
            setURLError(ERRORS.WEBSITE_HTTPS_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setURLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setURLError(null);
        }
        setWebsiteUrl(value);
    }

    const handelGpmKeyValidation = (value) => {
        setIsDirty(true);
        if(value.length <= 0) {
            setGpmKeyError(ERRORS.MISSING_KEY);
        }
        else if(value.trim().length <=0 ) {
            setGpmKeyError(ERRORS.INVALID_KEY);
        }
        else {
            setGpmKeyError(null);
        }
        setGpmKey(value);
    }

    const handelGpmAPIKeyValidation = (value) => {
        setIsDirty(true);
        if(value.length <= 0) {
            setGpmRestAPIKeyError(ERRORS.MISSING_KEY);
        }
        else if(value.trim().length <=0 ) {
            setGpmRestAPIKeyError(ERRORS.INVALID_KEY);
        }
        else {
            setGpmRestAPIKeyError(null);
        }
        setGpmRestAPIKey(value);
    }

    const handelSafariWebPushId = (value) => {
        setIsDirty(true);
        if(value.length > 0 && value.trim().length <=0 ) {
            setSafariWebPushIdError(ERRORS.INVALID_KEY);
        }
        else
        {
            setSafariWebPushIdError(null);
        }
        setSafariWebPushId(value);
    }

    const isSaveDisabled = () => {
        return title.length <= 0 || (website?.active_subscriber_count < 5 && (url.length <= 0 || urlError)) || titleError || gpmKey.length <= 0 || gpmRestAPIKey.length <= 0 ||
        gpmKeyError || gpmRestAPIKeyError || safariWebPushIdError;
    }


    const onSave = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('title', title);
        if(gpmKey) {
            formData.append('gpm_account_key', gpmKey);
        }
        if(gpmKey.trim().length >= 0 && gpmRestAPIKey) {
            formData.append('gpm_rest_api_key', gpmRestAPIKey);
        };
        createWeb.mutate(formData)
    }

    const createWeb = useMutation((formData) => {
        return updateWebSite(formData, website.id)
    }, {
        onSuccess: ((webSiteData) => {
            if(webSiteData.errors) {
                if(webSiteData.errors.url) {
                    toast.errors(webSiteData.errors.url[0]);
                }
            } else {
                updateWebsites(webSiteData);
                
                setIsDirty(false);
                toast.success('The update operation completed successfully.');
                history.push('/websites-setup')
                
            }
        //    setOpenDialogue(false);
        }),
        onError: ((error) => {
            console.log(error);
            // toast.error(error.message);
        })
    });

    const onBack = () => {
        if(isDirty) {
            setDiscardPromptOpen(true);
            setPathToNavigate('/websites-setup');
        } else {
            history.goBack();
        }
    }


    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">
                        <i className="icon icon-chevron-left mr-2" onClick={onBack} ></i> Edit Website
                    </h3>
                </div>                                
            </div>
            <div className="panel-body scrollable_y">
            <div className="row">
                <div className="col-12 col-lg-8">
                    <div className="form-group">
                        <label className="form-label text-dark medium">Website Name *</label>
                        <div className="input-addon input-group-right">
                            <i className="icon icon-edit"></i>
                            <input 
                                type="text" 
                                placeholder="Website Name" 
                                className="form-control"
                                value={title} 
                                onChange={({target}) => handelTitleValidation(target.value)}
                            />
                        </div>
                        { titleError && <span className="error-message">{titleError}</span>}
                    </div>
                   { website?.active_subscriber_count < 5 && <div className="form-group">
                        <label className="form-label text-dark medium">Website URL *</label>
                        <div className="input-addon input-group-right">
                            <i className="icon icon-website"></i>
                            <input 
                                type="text"
                                placeholder="Website URL"
                                className="form-control"
                                value={url} 
                                onChange={({target}) => handelUrlValidation(target.value)}
                            />
                        </div>
                        { urlError && <span className="error-message">{urlError}</span>}
                    </div>}
                    {
                        website?.is_migrated_from_gpm && <>
                        <div className="form-group">
                            <label className="form-label text-dark medium">GPM Key *</label>
                            <div className="input-addon input-group-right">
                                <i className="icon icon-edit"></i>
                                <input 
                                    type="text"
                                    placeholder="GPM Key"
                                    className="form-control"
                                    value={gpmKey} 
                                    onChange={({target}) => handelGpmKeyValidation(target.value)}
                                />
                            </div>
                            { gpmKeyError && <span className="error-message">{gpmKeyError}</span>}
                        </div>
                        <div className="form-group">
                            <label className="form-label text-dark medium">GPM Rest-API Key *</label>
                            <div className="input-addon input-group-right">
                                <i className="icon icon-edit"></i>
                                <input 
                                    type="text"
                                    placeholder="GPM Rest-API key"
                                    className="form-control"
                                    value={gpmRestAPIKey} 
                                    onChange={({target}) => handelGpmAPIKeyValidation(target.value)}
                                />
                            </div>
                            { gpmRestAPIKeyError && <span className="error-message">{gpmRestAPIKeyError}</span>}
                            </div>
                        <div className="form-group">
                            <label className="form-label text-dark medium">GPM Safari Push Id </label>
                            <div className="input-addon input-group-right">
                                <i className="icon icon-edit"></i>
                                <input 
                                    type="text"
                                    placeholder="GPM Safari Push Id"
                                    className="form-control"
                                    value={safariWebPushId} 
                                    onChange={({target}) => handelSafariWebPushId(target.value)}
                                />
                            </div>
                            { safariWebPushIdError && <span className="error-message">{safariWebPushIdError}</span>}
                        </div>
                        </>
                    }
                    <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={onSave} >Update</button>
                </div>
            </div>
        </div>
    </div>
</>

}

export default EditWebsite;